import React, { useState, useEffect } from 'react'
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
} from '@mui/material'
import { useGetMaps } from '../../hooks/api/map'
import Row from './Row'
import ErrorMessage from '../errors/ErrorMessage'
import { LoadingSkeletonRows } from '../_ui/LoadingSkeletonRows'

const Table = ({ searchKey }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const { data, isLoading, refetch, error } = useGetMaps({
    page: page + 1,
    limit: rowsPerPage,
    searchKey,
  })

  const handleChangePage = (_, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  useEffect(() => setPage(0), [searchKey])

  return (
    <Box paddingTop={'2rem'}>
      {error ? (
        <ErrorMessage error={error} onRetry={refetch} />
      ) : data?.docs?.length > 0 || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell width={'15%'}>HTG Company</TableCell>
                  <TableCell width={'15%'}>Company Account ID</TableCell>
                  <TableCell width={'45%'}>Company Name</TableCell>
                  <TableCell width={'25%'}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={4} />
                ) : (
                  data.docs.map((row) => <Row data={row} key={row.id} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
          {!isLoading && (
            <TablePagination
              component='div'
              count={data.totalDocs || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      ) : (
        <ErrorMessage empty />
      )}
    </Box>
  )
}

export default Table
